function setCookie99(name, value, expiresInMs) {
  try {
    var expires = '';
    if (expiresInMs) {
      var date = new Date();
      date.setTime(date.getTime() + expiresInMs);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  } catch (e) {}
}

function getCookie99(name) {
  try {
    var nameEQ = name + '=';
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length));
      }
    }
    return null;
  } catch (e) {
    return null;
  }
}

var SUBSCRIBED_COOKIE_MS_99 = 30 * 24 * 60 * 60 * 1000; // 30 days
var DISMISSED_COOKIE_MS_99 = 24 * 60 * 60 * 1000; // 24 hours

class Popup99 extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.trigger = this.querySelector('.popup-99__trigger');
    this.panel = this.querySelector('.popup-99__panel');
    this.overlay = this.querySelector('.popup-99__overlay');
    this.closeButton = this.querySelector('.popup-99__close');

    var wrapperEl = this.panel.querySelector('[data-form-id]');
    this.formId = wrapperEl ? wrapperEl.dataset.formId : null;
    this.awaitingReset = false;
    this.dismissTimer = null;

    this.panel.hidden = false;
    this.panel.setAttribute('inert', '');

    this.trigger.addEventListener('click', this.togglePanel.bind(this));
    this.closeButton.addEventListener('click', this.handleClose.bind(this));
    this.overlay.addEventListener('click', this.handleClose.bind(this));

    this.initialized = true;

    this.setupAutoBehavior(wrapperEl);
  }

  isSubscribed() {
    return getCookie99('newsletter99_subscribed') === 'true';
  }

  wasDismissedThisSession() {
    return getCookie99('newsletter99_dismissed') === 'true';
  }

  setupAutoBehavior(wrapperEl) {
    // By the time this runs, the wrapper's own inline script (in
    // newsletter-form-99.liquid) has already checked the URL hash and
    // corrected wrapper.dataset.state to 'form' if this popup instance
    // was NOT actually the one submitted. So if it's still 'success'
    // here, this popup's own form was genuinely submitted.
    var justSucceeded = wrapperEl && wrapperEl.dataset.state === 'success';

    if (justSucceeded) {
      setCookie99('newsletter99_subscribed', 'true', SUBSCRIBED_COOKIE_MS_99);

      this.hideTrigger();
      this.awaitingReset = true;
      this.openPanel();
      this.startDismissTimer();
      return;
    }

    if (this.isSubscribed()) {
      this.hideTrigger();
      return;
    }

    if (this.wasDismissedThisSession()) {
      return;
    }

    this.armScrollTrigger();
  }

  armScrollTrigger() {
    var self = this;
    var fired = false;
    var threshold = window.innerHeight * 0.5;

    var onScroll = function () {
      if (fired) return;
      if (self.isSubscribed()) {
        fired = true;
        window.removeEventListener('scroll', onScroll);
        return;
      }
      if (window.scrollY > threshold) {
        fired = true;
        window.removeEventListener('scroll', onScroll);
        self.openPanel();
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  hideTrigger() {
    if (this.trigger) this.trigger.style.display = 'none';
  }

  togglePanel() {
    var isOpen = this.panel.classList.contains('is-open');
    isOpen ? this.handleClose() : this.openPanel();
  }

  openPanel() {
    this.panel.classList.add('is-open');
    this.panel.removeAttribute('inert');
    this.overlay.classList.add('is-open');
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  closePanel() {
    this.panel.classList.remove('is-open');
    this.panel.setAttribute('inert', '');
    this.overlay.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  startDismissTimer() {
    var self = this;
    if (this.dismissTimer) clearTimeout(this.dismissTimer);
    this.dismissTimer = setTimeout(function () {
      self.resetAndClose();
    }, 5000);
  }

  resetAndClose() {
    if (this.dismissTimer) {
      clearTimeout(this.dismissTimer);
      this.dismissTimer = null;
    }

    var api = window.NewsletterForms && this.formId ? window.NewsletterForms[this.formId] : null;
    if (api && api.reset) api.reset();
    if (window.NewsletterForms && window.NewsletterForms.cleanUrl) {
      window.NewsletterForms.cleanUrl();
    }

    this.awaitingReset = false;
    this.closePanel();
  }

  handleClose() {
    if (this.awaitingReset) {
      this.resetAndClose();
    } else if (!this.isSubscribed()) {
      setCookie99('newsletter99_dismissed', 'true', DISMISSED_COOKIE_MS_99);
      this.closePanel();
    } else {
      this.closePanel();
    }
  }
}

customElements.define('popup-99', Popup99);